import { MainContainer } from "../../component/container";
import { useNavigate } from 'react-router';
import Do from '../../assets/image/Do.jpg'
import Do1 from '../../assets/image/Do1.gif'
import BouncingIcon from "../../component/BouncingIcon";
import ICO from '../../assets/ico/pp.png'
import { Element, Link } from 'react-scroll';
import { useState } from "react";
import Paypal from "../../component/Paypal";

export default function Donate() {
    const [amount, setAmount] = useState(10)
    const navigate = useNavigate();
    const [checkOut, setCheckOut] = useState(false)

    return (
        <MainContainer>
            <div id='content' className="">
                <img src={Do} alt="Do" className='w-screen h-screen object-cover opacity-70' />

                <div className="w-full absolute top-1/2 left-0 transform -translate-y-1/2 2xl:px-80 xl:px-52 px-10">
                    <div className="bg-[#87ceeb] bg-opacity-70 p-4 rounded-full">
                        <h1 className="text-lg sm:text-4xl font-bold text-white text-center">Donate Today.</h1>
                    </div>
                </div>


                <Link to="Scroll" smooth={true} duration={500}>
                    <BouncingIcon />
                </Link>
            </div>
            <Element name="Scroll" className="element"><div className='min-h-[2px]'></div></Element>

            <div className="2xl:px-80 xl:px-52 px-10 mt-24 flex flex-col gap-20">
                <div className="flex items-center justify-center italic">
                    We thank God for your gift of life today!
                </div>
                <div className="">
                    <img src={Do1} alt="Do1" className=' w-full' />
                </div>
                <div className="flex flex-col items-center">
                    <span>"LIVING IN US, The ACRFI IS A 501 (C) (3) NON PROFIT ORGANIZATION AND YOUR DONATION TO US IS TAX DEDUCTIBLE!"</span>

                    <span>Below, please choose the best way to send your donation and assist us save orphans and street children today!</span>
                </div>

                <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 text-center">
                    <div className="flex flex-col items-center gap-5">
                        <span className="font-bold text-lg underline">1. Online</span>

                        <span className="">Please click on the buton (A PAYPAL link) below:</span>
                        {checkOut ?
                            <Paypal amount={amount} checkOut={checkOut} setCheckOut={setCheckOut} />
                            : (
                                <div>

                                    <label htmlFor="amount">Montant: USD </label>
                                    <input
                                        type="number"
                                        id="amount"
                                        name="amount"
                                        value={amount}
                                        className="border rounded-md p-1"
                                        onChange={(e) => setAmount(e.target.value)}
                                    />
                                    <img src={ICO} alt={'ICO'} className="cursor-pointer w-10" onClick={() => setCheckOut(true)} />
                                </div>

                            )}
                        <span>(Sending your donations online with Paypal is secure and confidential as Paypal does not reveal or share your Credit Card or bank account information with anyone else.)</span>
                    </div>
                    <div className="flex flex-col gap-5">
                        <span className="font-bold text-lg underline">2. By Mail</span>

                        <span>Send your check to:</span>
                        <span className="text-xl font-bold text-[#2E51A9]">A. In US :</span>
                        <div className="flex flex-col ">
                            <span>Make and send your Check (in USD) payable to:</span>

                            <span>THE ACRFI</span>
                            <span>1167 NW 49th STREET</span>
                            <span>MIAMI, FL.33127</span>
                            <span>OR CALL: 1-305-607-2284 FOR MORE INFORMATION</span>
                        </div>
                        <span className="text-xl font-bold text-[#2E51A9]">B. In The Democratic Republic of Congo: :</span>
                        <div className="flex flex-col ">
                            <span>Make and send your Check payable to:</span>

                            <span>CHRISTINE KALOMBA / Congo ACRFI Rep</span>
                            <span>2996 Lac Kipopo, Q.Gambela II</span>
                            <span>Commune Lubumbashi</span>
                            <span>Katanga, Congo (DRC)</span>
                            <span>Or CALL: 011-243-99-873-7019 FOR MORE INFORMATION</span>
                        </div>
                    </div>
                    <div className="flex flex-col ">
                        <span className="font-bold text-lg underline">3. By becoming a partner to the ACRFI</span>
                        <span>
                            Become a partner and send us your monthly contribution of $25.00 USD or more...; as we put your name on the list of our silver angelic donors to save street children in US & Congo DRC.
                        </span>
                        <span className='mt-3'>
                            TO BECOME A PARTNER, Click HERE! [This link is under construction].
                            In the meantime, please send us your request at our <span className="text-blue-400 hover:underline cursor-pointer" onClick={() => { navigate('/Location/Team') }}>headquarter office</span>.
                        </span>
                    </div>
                </div>

                <div className="text-center">
                    We thank God for your generous donation and the care for orphans today!
                    Coming together, we can stop the suffering and death of Orphan Children in the Congo DRC, by getting them off the streets and providing them with a shelter, security and an education; as well as finding solutions to reintegrate US wondering street children into school systems!
                </div>
            </div>
        </MainContainer>
    )
}